import { render } from "./Usuario.vue?vue&type=template&id=1af6c4a6"
import script from "@/assets/js/usuario.js?vue&type=script&lang=js"
export * from "@/assets/js/usuario.js?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__